/* eslint-disable arrow-parens */
/* eslint-disable no-new */
import './vendor';
import './helpers';
import './components/social';
import './components/analytics';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import {actualYear} from './modules/actualYear';
import header from './components/header';
import lazyLoading from './modules/lazyLoading';
import scrollToAnchor from './modules/scrollToAnchor';
import PopupMini from './components/PopupMini';
// import Popup from './components/Popup';
import sliders from './components/sliders';
import sliderStars from './components/sliderStars';
import partnersSlider from './components/partnersSlider';
import fullpageScroll from './components/fullpageScroll';
import AOS from 'aos';
import addAnomationContent from './components/addAnomationContent';
import newsShowMore from './components/newsShowMore';
import form from './components/form';
import dropdown from './components/dropdown';
import addNewForm from './components/addNewForm';
import changeVote from './components/changeVote';
import {Fancybox} from '@fancyapps/ui';
import formAssessment from './components/formAssessment';
import showMore from './components/showMore';
import setBackBtn from './components/setBackBtn';
import showPassword from './components/showPassword';
import popupApplication from './components/popupApplication';

ieFix();
vhFix();
actualYear();
scrollToAnchor.init();

header.init();
lazyLoading.init();
sliders.init();
sliderStars.init();
partnersSlider.init();
fullpageScroll.init();
newsShowMore.init();
addAnomationContent.init();
form.init();
dropdown.init();
addNewForm.init();
changeVote.init();
Fancybox.bind('.contents-page__img-group div', {
	groupAll: true, // Group all items
});
formAssessment.init();
showMore.init();
setBackBtn.init();
showPassword.init();

// export let popupRegistration;

window.addEventListener('load', () => {
	if (document.querySelector('.main-page__about-more')) {
		new PopupMini('.main-page__about-more');
	}
	// popupRegistration = new Popup('.popup-registration-main', '.js-popup-registration', true);
	// if (document.querySelector('.btn-social-auth')) {
	// 	// eslint-disable-next-line no-unused-vars
	// 	const popupAuth = new Popup('.popup-social-auth', '.btn-social-auth', true);
	// }
	AOS.init({
		duration: 600,
		once: true,
	});
	popupApplication.init();
	document.querySelector('html').style.opacity = 1;
});

// change height hero-section for mobile
let debonce = false;

const arrayChangeHeight = [
	document.querySelector('.main-page__hero'),
	document.querySelector('.popup-registration'),
];

function setHeight() {
	if (!debonce) {
		arrayChangeHeight.forEach(el => {
			if (el) {
				let currentHeight = window.innerHeight;
				el.style.height = `${currentHeight}px`;

				debonce = true;
				setTimeout(() => {
					debonce = false;
				}, 200);
			}
		});
	}
}

setHeight();

window.addEventListener('resize', setHeight);

// отложенная загрузка видео с youtube
// setTimeout(() => {
// 	if (document.querySelector('.frame-youtube')) {
// 		document.querySelectorAll('.frame-youtube').forEach(el => {
// 			// const video = document.createElement('iframe');
// 			// video.src = el.dataset.src;
// 			// video.allowfullscreen = true;
// 			// el.append(video);
// 			el.src = el.dataset.src;
// 		});
// 	}
// }, 1500);

if (document.querySelector('.frame-cover')) {
	document.querySelectorAll('.frame-cover').forEach((el) => {
		el.addEventListener('click', (e) => {
			e.preventDefault();
			el.classList.add('is-hidden');

			const frameEl = el.nextElementSibling;
			const frame = frameEl.querySelector('.frame-youtube');

			frame.src = frame.dataset.src;
		});
	});
}

function switchForm(btn) {
	const allForm = btn.closest('.popup-registration__wrapper').querySelectorAll('form');

	allForm.forEach(el => {
		if (!el.classList.contains('is-visible')) {
			el.classList.add('is-visible');
			el.style.display = 'block';
		} else {
			el.classList.remove('is-visible');
			el.style.display = 'none';
		}
	});
}

document.querySelectorAll('.switch-form-js').forEach(el => {
	el.addEventListener('click', (e) => {
		switchForm(e.currentTarget);
	});
});
